import { useEffect, useRef } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';

import { useAppDispatch, useAppSelector } from '../redux/hooks';
import { identityGoogleCallbackStart } from '../redux/identity/identitySlice';

const GoogleCallback = () => {
 const dispatch = useAppDispatch();
 const navigate = useNavigate();
 const [searchParams] = useSearchParams();
 const hasDispatched = useRef(false);

 const { success, loading, error } = useAppSelector((state) => state.identity);

 const code = searchParams.get('code');
 const redirectUri =
  searchParams.get('redirectUri') ||
  `${window.location.origin}/google-callback`;

 useEffect(() => {
  if (code && !hasDispatched.current) {
   hasDispatched.current = true;
   dispatch(identityGoogleCallbackStart({ code, redirectUri }));
  }
 }, [code, redirectUri, dispatch]);

 useEffect(() => {
  if (success?.identityGoogleCallback) {
   navigate('/results', { replace: true });
  }
 }, [success?.identityGoogleCallback, navigate]);

 if (!code) {
  return (
   <Box
    sx={{
     display: 'flex',
     flexDirection: 'column',
     alignItems: 'center',
     justifyContent: 'center',
     minHeight: '100vh',
     gap: 2,
    }}
   >
    <Typography variant="body1" color="error">
     Missing authorization code
    </Typography>
   </Box>
  );
 }

 if (error?.identityGoogleCallback) {
  return (
   <Box
    sx={{
     display: 'flex',
     flexDirection: 'column',
     alignItems: 'center',
     justifyContent: 'center',
     minHeight: '100vh',
     gap: 2,
    }}
   >
    <Typography variant="body1" color="error">
     {error.identityGoogleCallback.title || 'Authentication failed'}
    </Typography>
   </Box>
  );
 }

 return (
  <Box
   sx={{
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    gap: 2,
   }}
  >
   <CircularProgress />
   <Typography variant="body1">
    {loading?.identityGoogleCallback ? 'Signing in...' : 'Processing...'}
   </Typography>
  </Box>
 );
};

export default GoogleCallback;

